<template>
  <b-modal
    id="modalDenuncia"
    :ok-only="true"
    hide-footer
    ok-variant="danger"
    ok-title="Fechar"
    size="lg"
    ref="modal"
  >
    <div class="flex flex-column">
      <p class="text-center font-weight-bold text-title">Denúncia Registrada com sucesso</p>
      <p class="text-center text-body">Sua denúncia foi registrada em nosso sistema e em breve será analisada. Utilize o protocolo abaixo para acompanhar novas atualizações.</p>
      <p :style="{ backgroundColor: empresa.cor_site_media }" class="text-center font-weight-bold protocolo">{{ protocolo }}</p>
      <p class="text-center font-weight-bold text-body">Guarde este protocolo em um lugar seguro, pois somente com ele você poderá acompanhar sua denúncia.</p>
      <router-link :style="{ backgroundColor: empresa.cor_site_escura }" to="acompanhar-denuncia" class="btn-acompanhar mt-3"><p class="mb-0 btn-text">Acompanhar</p></router-link>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ModalDenuncia",
  props: {
    visible: Boolean,
    protocolo: String,
    empresa: Object
  },
  watch: {
    visible() {
      this.$bvModal.show("modalDenuncia");
    },
  },
  methods: {},
};
</script>

<style scoped>
  .text-title {
    font-size: 26px;
  }

  .text-body {
    font-size: 18px;
  }

  .protocolo {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 65px;
    width: 250px;
    border-radius: 5px;
    color: white;
    font-size: 20px;
  }

  .btn-acompanhar {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px;
    width: 180px;
    border-radius: 5px;
  }

  .btn-text {
    color: white;
    font-weight: bold;
    font-size: 20px;
  }

  li a {
    text-decoration: none;
  }

  a:not(.md-button):hover {
    text-decoration: none;
  }

@media (max-width: 374px) {
  .text-title {
    font-size: 18px;
  }

  .text-body {
    font-size: 14px;
  }

  .protocolo {
    height: 45px;
    width: 180px;
    font-size: 18px;
  }

  .btn-acompanhar {
    height: 50px;
    width: 120px;
  }

  .btn-text {
    font-size: 14px;
  }
}

@media (min-width: 375px) and (max-width: 576px) {
  .text-title {
    font-size: 18px;
  }

  .text-body {
    font-size: 14px;
  }

  .protocolo {
    height: 45px;
    width: 180px;
    font-size: 18px;
  }

  .btn-acompanhar {
    height: 50px;
    width: 120px;
  }

  .btn-text {
    font-size: 14px;
  }
}

@media (min-width: 577px) and (max-width: 768px) {
  .text-title {
    font-size: 20px;
  }

  .text-body {
    font-size: 16px;
  }

  .protocolo {
    height: 45px;
    width: 220px;
    font-size: 18px;
  }

  .btn-acompanhar {
    height: 50px;
    width: 160px;
  }

  .btn-text {
    font-size: 16px;
  }
}

@media (min-width: 769px) and (max-width: 992px) {
  .text-title {
    font-size: 20px;
  }

  .text-body {
    font-size: 16px;
  }

  .protocolo {
    height: 45px;
    width: 220px;
    font-size: 18px;
  }

  .btn-acompanhar {
    height: 50px;
    width: 160px;
  }

  .btn-text {
    font-size: 16px;
  }
}

</style>